// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"9c0bbaf6","250":"2a1dbf09","407":"730fa123","436":"dc5f50c6","453":"f394a27d","455":"2b9dbaca","501":"c478e388","595":"78477874","606":"ad434890","691":"8e0edf1e","821":"b0554a88","880":"d2b15436","925":"71f6874e","969":"848f4233"}[chunkId] + ".chunk.js";
};